import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <main id='main' className='flex w-full flex-1 flex-col items-center overflow-clip'>
            <div className='relative z-[2] flex w-full max-w-[1728px] flex-col items-center bg-background'>
                {children}
            </div>
        </main>
    )
}
